export default __webpack_public_path__ + "static/media/DellTechnologiesLogo.be89ec14.svg";